// @ts-ignore
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

// @ts-ignore
import introVideo from "@/assets/images/brion_vedio.mp4";

const heroVideo = [{
  id: 1,
  video: introVideo,
}]

export default function HeroSection() {
  // @ts-ignore
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="hero" className="relative">
      {/* Video Background with Title */}
      <div className="relative h-screen flex items-center justify-center overflow-hidden">
        {heroVideo.map((videos) => (
          <div key={videos.id} className="absolute inset-0 z-0 bg-primary">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-box"
            >
              <source src={videos.video}
                type="video/mp4" />
            </video>
            <div className="absolute inset-0 bg-gradient-to-b via-primary/80"></div>
          </div>
        ))}

        {/* Title on Video */}
        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading font-bold text-xl sm:text-2xl lg:text-4xl text-white mb-4 sm:mb-6 leading-tight">
            Rise Together with India's<br className="hidden sm:block" />
            <span className="sm:hidden"> </span>Financial Growth
          </h1>
        </div>
      </div>

      {/* Content Below Video */}
      <div className="bg-primary w-full">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-12 sm:py-16">
          <p className="text-base sm:text-lg md:text-xl text-white/90 mb-3 sm:mb-4 max-w-3xl mx-auto leading-relaxed px-2">
            From individual ambition to national progress, Brion bridges the gap between potential and reality through disciplined, research-driven investing.
          </p>

          <p className="text-sm sm:text-base md:text-lg text-accent font-medium mb-8 sm:mb-10 px-2">
            Laser sharp focus. Long-term value.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-12 sm:mb-16 px-2">
            <
              // @ts-ignore
              Button
              size="lg"
              className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold px-8 text-base w-full sm:w-auto"
              onClick={() => scrollToSection('#contact')}
            >
              Get in Touch
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <
              // @ts-ignore
              Button
              size="lg"
              className="bg-white text-primary hover:bg-white/90 font-semibold px-8 text-base w-full sm:w-auto"
              onClick={() => scrollToSection('#who-we-are')}
            >
              Learn More
            </Button>
          </div>

          {/* Trust Strip */}
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-white/80 px-2">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="h-4 w-4 text-accent flex-shrink-0" />
              <span>Based in Mumbai</span>
            </div>
           
            <div className="flex items-center gap-2">
              <CheckCircle2 className="h-4 w-4 text-accent flex-shrink-0" />
              <span>SEBI & Exchange Compliant</span>
            </div>
          </div>
        </div>
      </div>

    </section>

  );
}